<div class="h-screen overflow-hidden">
  <vw-header-padding-safe-area></vw-header-padding-safe-area>
  <!-- Colonne flex : la liste doit prendre la place RESTANTE. En `h-full`
       elle réclamait toute la hauteur d'écran quoi qu'il y ait au-dessus, et
       son bas passait sous le viewport — 80 px avant la carte lunaire, 342 px
       après. -->
  <div class="pb-8 overflow-hidden h-full flex flex-col">
    <!-- Page title + climate selector inline -->
    <div class="flex items-baseline justify-between px-4 pb-3 gap-3">
      <h2 class="text-[#062825] text-[32px] font-semibold shrink-0">{{ 'calendar.title' | translate }}</h2>
      <vw-climate-banner
        [selectedClimateType]="selectedClimateType"
        [myClimateType]="myClimateType"
        (pickerClick)="isClimatePickerOpen = true">
      </vw-climate-banner>
    </div>

    <!-- « Ta semaine lunaire » : le calendrier est déjà l'endroit où l'on
         regarde quand semer et quand récolter — le jour lunaire y répond à la
         même question. -->
    <div class="px-4 pb-3">
      <vw-lunar-week></vw-lunar-week>
    </div>

    <div class="flex items-center justify-between px-4 pt-2 mb-1 gap-4 relative z-20">
      <div class="grow"><vw-text-input (valueChange)="onSearch($event)" icon="search" [prefix]="prefix"
          placeholder="agenda.search.placeholder">
          <ng-template #prefix>
            <div class="w-5 h-5 flex items-center justify-center text-gray-500">
              <vw-plant-icon></vw-plant-icon>
            </div>
          </ng-template>
        </vw-text-input></div>
      <div class="size-10 p-2.5 bg-grey-100 rounded-lg flex items-center justify-center text-gray-600"
        (click)="isSortingModalOpen = true">
        <vw-sort-icon></vw-sort-icon>
      </div>
    </div>
    <vw-calendar-hierarchies class="flex-1 min-h-0" [hierarchies]="currentMonthCalendarItems" [isLoading]="isLoading"
      (cultivationSelected)="onCultivationSelected($event)">
    </vw-calendar-hierarchies>


    <!-- Empty state when browsing another climate with no results -->
    @if (!isLoading && currentMonthCalendarItems.length === 0 && selectedClimateType) {
      <div class="flex flex-col items-center justify-center gap-4 mt-12 px-8">
        <img src="/assets/images/willy/resized/willy_dontknow.png" alt="Willy" class="w-40 object-contain" />
        <p class="text-grey-500 text-sm text-center">{{ 'calendar.climate.empty' | translate }}</p>
        <button
          class="bg-primary text-white rounded-full py-3 px-8 text-sm font-medium"
          (click)="onClimateSelected(null)">
          {{ 'calendar.climate.backToMine' | translate }}
        </button>
      </div>
    }

    <vw-cultivation-guide-toast [isOpen]="isShowingGuide" [cultivation]="selectedCultivation"
      [cultivationVariant]="selectedVariant" (close)="isShowingGuide = false">
    </vw-cultivation-guide-toast>
    <vw-calendar-sort-toast [isOpen]="isSortingModalOpen" (close)="isSortingModalOpen = false"
      (sortChange)="onSortChange($event.sort, $event.sortDirection)"></vw-calendar-sort-toast>
    <vw-climate-info-toast [isOpen]="isClimateInfoOpen" (close)="isClimateInfoOpen = false"></vw-climate-info-toast>
    <vw-climate-picker-toast
      [isOpen]="isClimatePickerOpen"
      [availableClimates]="availableClimates"
      [selectedClimateType]="selectedClimateType"
      [myClimateType]="myClimateType"
      (close)="isClimatePickerOpen = false"
      (climateSelected)="onClimateSelected($event)"
      (infoClick)="isClimateInfoOpen = true">
    </vw-climate-picker-toast>
  </div>
</div>